import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  list: {
    width: "inherit",
  },
  chip: {
    cursor: "pointer",
    margin: "0 1%",
  },
  card: {
    width: "inherit",
    cursor: "pointer",
  },
  cardContent: {
    width: "100%",
  },
  listIcon: {
    minWidth: "50px",
  },
  chipGrid: {
    lineHeight: "50px",
  },
  icon: {
    cursor: "pointer",
  },
  filterBox: {
    marginBottom: theme.spacing(2),
  },
  filterChip: {
    cursor: "pointer",
    margin: "0 1%",
  },
  filterContainer: {
    width: "100%",
    paddingLeft: theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  mobileAdd: {
    "& .MuiButton-startIcon": {
      margin: 0,
    },
  },
  dateIndicator: {
    fontSize: "large",
    fontWeight: "bold",
  },
  editGrid: {
    textAlign: "right",
    margin: "0 auto",
  },
  loadingSpinner: {
    textAlign: "center",
  },
}));
